import EnvioTypes from "./types";

export const documentosPendentes = (contrato, onSuccess, onError) => ({
  type: EnvioTypes.COMPLEMENTO_DOCUMENTOS_PENDENTES,
  contrato,
  onSuccess,
  onError,
});

export const clear = () => ({
  type: EnvioTypes.CLEAR,
});

export const clearIncluidos = () => ({
  type: EnvioTypes.CLEARINCL,
});

export const include = (MAX_ITENS_POR_PROTOCOLO, selecionados, tipo_protocolo) => ({
  type: EnvioTypes.INCLUDE,
  MAX_ITENS_POR_PROTOCOLO,
  selecionados,
  payload: { tipo_protocolo },
});

export const remove = (id, tipo_protocolo) => ({
  type: EnvioTypes.REMOVE,
  payload: { id, tipo_protocolo },
});

export const searchProtocoloRequest = (id) => ({
  type: EnvioTypes.SEARCH_PROTOCOLO_REQUEST,
  param: id,
});

export const searchProtocoloSuccess = (data) => ({
  type: EnvioTypes.SEARCH_PROTOCOLO_SUCCESS,
  payload: data,
});

export const searchRequest = (param) => ({
  type: EnvioTypes.SEARCH_REQUEST,
  param,
});

export const searchFailure = () => ({
  type: EnvioTypes.SEARCH_FAILURE,
});

export const searchSuccess = (contratos) => ({
  type: EnvioTypes.SEARCH_SUCCESS,
  payload: contratos,
});

export const select = (id, visibleIds) => ({
  type: EnvioTypes.SELECT,
  payload: { id, visibleIds },
});

export const selectMultiples = (ids, checked) => ({
  type: EnvioTypes.SELECT_MULTI,
  payload: { ids, checked },
});

export const clearSelected = () => ({
  type: EnvioTypes.CLEAR_SELECT,
});

export const saveRequest = (tipo, numero_envelope, dados_usuario) => ({
  type: EnvioTypes.SAVE_REQUEST,
  payload: { tipo, numero_envelope, dados_usuario },
});

export const saveSuccess = (response) => ({
  type: EnvioTypes.SAVE_SUCCESS,
  payload: response,
});

export const selectsRequest = (tipo) => ({
  type: EnvioTypes.SELECTS_REQUEST,
  payload: { tipo },
});

export const selectsSuccess = (response) => ({
  type: EnvioTypes.SELECTS_SUCCESS,
  payload: response,
});

export const requestFailure = (response) => ({
  type: EnvioTypes.REQUEST_FAILURE,
  payload: response,
});

export const forceInclude = (id) => ({
  type: EnvioTypes.FORCE_INCLUDE,
  payload: id,
});

export const forceIncludeDocumentos = (payload) => ({
  type: EnvioTypes.FORCE_INCLUDE_DOCUMENTOS,
  payload,
});

export const listaPromotorasRequest = (filter) => ({
  type: EnvioTypes.LISTA_PROMOTORAS_REQUEST,
  payload: filter,
});

export const listaPromotorasSuccess = (response) => ({
  type: EnvioTypes.LISTA_PROMOTORAS_SUCCESS,
  payload: response,
});

export const listaLojasRequest = (filter) => ({
  type: EnvioTypes.LISTA_LOJAS_REQUEST,
  payload: filter,
});

export const listaLojasSuccess = (response) => ({
  type: EnvioTypes.LISTA_LOJAS_SUCCESS,
  payload: response,
});

export const listaConveniosRequest = (filter) => ({
  type: EnvioTypes.LISTA_CONVENIOS_REQUEST,
  payload: filter,
});

export const listaConveniosSuccess = (response) => ({
  type: EnvioTypes.LISTA_CONVENIOS_SUCCESS,
  payload: response,
});

export const listaProdutosRequest = (filter) => ({
  type: EnvioTypes.LISTA_PRODUTOS_REQUEST,
  payload: filter,
});

export const listaProdutosSuccess = (response) => ({
  type: EnvioTypes.LISTA_PRODUTOS_SUCCESS,
  payload: response,
});

export const filterProdutoPorConvenio = (filter) => ({
  type: EnvioTypes.FILTER_PRODUTOS_POR_CONVENIO,
  payload: filter,
});

export const protocoloMassaRequest = (type, params, nomeSistema) => ({
  type: EnvioTypes.PROTOCOLO_MASSA_VALIDAR_REQUEST,
  payload: { type, params, nomeSistema },
});

export const protocoloMassaSuccess = (response) => ({
  type: EnvioTypes.PROTOCOLO_MASSA_VALIDAR_SUCCESS,
  payload: response,
});

export const protocoloMassaFailure = (response) => ({
  type: EnvioTypes.PROTOCOLO_MASSA_VALIDAR_FAUILURE,
  payload: response,
});

export const protocoloMassaClose = () => ({
  type: EnvioTypes.PROTOCOLO_MASSA_CLOSE,
});
